import React from 'react';
import { makeStyles } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import { ChangeEvent, MouseEvent, useState, SyntheticEvent, useEffect } from 'react'
import axios from '../services/ApiService'
import { InviteInfo } from 'src/types/apps/channelTypes'
import toast from 'react-hot-toast'

const InviteAccept = () => {

    const [inviteData, setInviteData] = useState<InviteInfo>();
    const [invitationAccepted, setInvitationAccepted] = useState<boolean>();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const inviteId = params.get("inviteId");
        if (inviteId) {
            axios.get('invite/GetInviteInfo?id=' + inviteId).then((data: any) => setInviteData(data.data));
        }
        else {
            //redirect to default page
        }
    }, [])

    const acceptInvitation = () => {
        const params = new URLSearchParams(window.location.search);
        const inviteId = params.get("inviteId");
        if (inviteId) {
            axios.post('invite/AcceptInvite?inviteGuidStr=' + inviteId).then((data: any) => {
                console.log(data);
                setInvitationAccepted(true)
                toast.success('The invite has been accepted.', {
                    duration: 3000
                });
            }
            );
        }
    }

    return (
        <>
            <Grid container spacing={6} sx={{ marginTop: "15px" }}>
                <Grid item xs={2}></Grid>
                <Grid item xs={8}>
                    {inviteData &&
                        <Card>
                            <CardHeader
                                title={"Invite to join organization " + inviteData.organizationName}
                            />
                            <CardMedia
                                component="img"
                                height="200"
                                width="100%"
                                image="https://cdn.discordapp.com/attachments/1063516306030203031/1092863816297095398/MoAB7_People_without_faces_celebrating_flat_design_cb9ea554-d17f-4453-8b5f-9c76e070babb.png"
                                title="Example Image"

                            />
                            <CardContent>
                                {
                                    !inviteData.accepted && !invitationAccepted &&
                                    <>
                                        <Typography variant="body2" color="textSecondary" component="p">
                                            We are  pleased to inform you that you have been invited to join social media channels for organization {inviteData.organizationName}.
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary" component="p">
                                            Upon accepting this invitation, you will gain access to the following channels and corresponding privileges.
                                        </Typography>
                                        <List>
                                            {inviteData.channels.map((channel) => <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar>
                                                        <img src={channel.imageUrl} alt={channel.name} />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary={channel.name} secondary={channel.privilegeName} />
                                            </ListItem>)}
                                        </List>
                                        <Button
                                            variant='outlined'
                                            color='secondary'
                                            disabled={invitationAccepted}
                                            onClick={() => acceptInvitation()}
                                        >
                                            Accept
                                        </Button>
                                    </>
                                }
                                {
                                    (inviteData.accepted) && <Typography variant="body2" color="textSecondary" component="p">
                                        You have already accepted this invitation.
                                    </Typography>
                                }
                                {
                                    invitationAccepted && <Typography variant="body2" color="textSecondary" component="p">
                                        Invitation Accepted. You can now start using channels assigned to you by the organization's Administrator.
                                    </Typography>
                                }
                            </CardContent>
                        </Card>
                    }
                </Grid>
                <Grid item xs={2}></Grid>
            </Grid>
        </>
    );
};

export default InviteAccept;